import { FormField } from '../forms/form-field.model';
import { FormSection } from '../forms/form-section.model';
import { FormHeader } from '../forms/form-header.model';

export class Workflow {

  constructor(
    public description?: string,
    public header?: FormHeader,
    public hiddenFields?: FormField[],
    public id?: number,
    public name?: string,
    public type?: string,
    public sections?: FormSection[],
    public validations?: WorkflowValidations,
    public wide: boolean = false
  ) { }
  
}

export interface WorkflowValidations {
  atLeastOneRequired: [[string]]
}


// WEBPACK FOOTER //
// ./src/app/workflows/workflow.model.ts